<template>
  <Button
    :style="styles"
    @click="confirm"
  >
    <slot/>
  </Button>
</template>

<script>
  export default {
    name: "my-button",
    props: {
      styles: {
        type: Object,
      },
    },
    data() {
      return {}
    },
    methods: {
      confirm() {
        //这里是激活父组件的事件，因为子组件是不会冒泡到父组件上的，必须手动调用$emit
        //相对应父组件要在调用该组件的时候，将其挂载到上面
        this.$emit("confirm")
      }

    }
  }
</script>

<style scoped lang="less">
  @import '../app.less';
  button {
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    width: 140px;
    height: 42px;
    outline: none;
    border: 0;
    background-color:@theme-c;
    border-radius:3px ;
    cursor: pointer;
  }
  button:hover{
    background-color:@theme-c;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyButton.vue